'use client';

import BaseSpinner from '@module/components/Spinner/BaseSpinner';
import { useGuideEmoticonListQuery } from '@module/queries/guide/guideQueryHooks';
import EmoticonListItem from '@pc/components/card/EmoticonListItem';
import BasePagenation from '@pc/components/pagenation/BasePagenation';

import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { keepPreviousData } from '@tanstack/react-query';
import { useState } from 'react';

const ITEMS_PER_PAGE = 15;

function NormalEmoticonListContainer() {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const currentPageFirstOffset = (currentPage - 1) * ITEMS_PER_PAGE;
  const [clickedIdx, setClickedIdx] = useState<number | null>(null);

  const { data: eventList, isLoading } = useGuideEmoticonListQuery(
    {
      offset: currentPageFirstOffset,
      limit: ITEMS_PER_PAGE,
      type: 'default',
    },
    {
      placeholderData: keepPreviousData,
    },
  );

  const isListEmpty = !isLoading && !eventList?.page.total;

  return (
    <div>
      {isLoading && <BaseSpinner className='mx-auto my-20' />}
      {isListEmpty ? (
        <NotFoundDisplay text={'검색결과가 없습니다.'} />
      ) : (
        <div className='mt-10 grid min-h-[660px] w-[1360px] grid-cols-5'>
          {eventList?.list.map((item) => (
            <EmoticonListItem
              key={item.idx}
              item={item}
              onClick={() => setClickedIdx(item.idx)}
              onBlur={() => setClickedIdx(null)}
              isClicked={clickedIdx === item.idx}
            />
          ))}
        </div>
      )}

      <BasePagenation currentPage={currentPage} setCurrentPage={setCurrentPage} pageData={eventList?.page} />
    </div>
  );
}

export default NormalEmoticonListContainer;
